import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

import { sHeader } from "../styled/header"
import { sLayout } from "../styled/layout"

import useSiteMetadata from "../hooks/use-site-metadata"

const Header = ({ toggleMenu }) => {
  const data = useStaticQuery(graphql`
    query {
      file(name: { eq: "logo" }) {
        childImageSharp {
          fluid(maxWidth: 205, traceSVG: { color: "#d9d9d9" }) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `)
  const { baseSite, title } = useSiteMetadata()
  return (
    <sHeader.Wrapper>
      <sLayout.Container>
        {baseSite ? (
          <div>
            <sHeader.Site href={baseSite.url} target="_blank" rel="noopener noreferrer">
              {baseSite.title}
            </sHeader.Site>
          </div>
        ) : null}
        <div>
          <sHeader.Logo to="/" aria-label={`${title} homepage`}>
            <Img fluid={data.file.childImageSharp.fluid} />
          </sHeader.Logo>
        </div>
        <div>
          <sHeader.Burger onClick={() => toggleMenu()} aria-label="Menu">
            <span />
            <span />
            <span />
          </sHeader.Burger>
        </div>
      </sLayout.Container>
    </sHeader.Wrapper>
  )
}

export default Header
